module.exports = __webpack_public_path__ + "assets/sousuo.4998a81b.svg";